var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bus-lines"},[_c('pub-info-title',{attrs:{"title":'实时监控',"is-modal-long":true}}),_c('div',{staticClass:"monitor-container"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }